import { ApiBaseService } from "./ApiBaseService";

interface AutoCompleteOptions {
    includedPrimaryTypes?: string[];
    languageCode?: string;
    includedRegionCodes?: string[];
    locationBias?: Record<string, any>;
    ipbias?: string;
    inputOffset?: number;
    regionCode?: string;
    sessionToken?: string;
}

export default class GoogleService extends ApiBaseService {
    public places() {
        const autocomplete = (
            input: string,
            options: Partial<AutoCompleteOptions> = {},
        ) => {
            const { language } = useNavigatorLanguage();

            if (!options.languageCode) {
                options.languageCode = language.value;
            }

            return this.request(
                this.route("api.google.autocomplete", "google/autocomplete"),
                {
                    method: "POST",
                    body: {
                        ...options,
                        input,
                    },
                },
            );
        };

        return {
            autocomplete,
        };
    }
}
